import React, { Fragment } from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';
import SubHeaderTicketDetail from './../components/SubHeaders/TicketSubHeader';
import { getUsersInvited } from 'Actions/projectActions';
import {
  getCurrentProject,
  getCurrentTicket,
  toggleTicketFavorite,
} from 'Actions/ticketActions';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { API_ROOT } from 'Api/Routes';
import { Link } from 'react-router-dom';
import PreviewImageModal from 'PreviewImageModal';

//Milan Andrejic
import styled from 'styled-components';
import Header from './components/Header';
import axios from 'Axios';
import FavButton from '../components/FavButton';
import moment from 'moment';
import { Divider } from '@material-ui/core';
// import dompurify from 'dompurify';

const Notes = styled.div`
  word-break: break-all;
  font-size: 12px;
`;
const GridAndStyleForFavoriteBtn = styled(Grid)`
  &&& svg {
    width: 3rem;
    height: 3rem;
  }
`;
const Buttons = styled(Button)`
  color: #37474f !important;
  :hover {
    background-color: #ffca28 !important;
  }
`;
const TicketWrapper = styled(Grid)`
  // &&& {
  //   @media screen and (min-width: 1224px) {
  //     padding-right: 10%;
  //     padding-left: 10%;
  //   }
  // }
`;

const ContainerMax = styled.div`
  max-width: 1024px;
  padding: 1.125rem 5.9375rem 3.125rem 5.9375rem;
  border-radius: 5px;
`;
const NoteNumb = styled.span`
  color: black;
  font-weight: bold;
`;
const Note = styled.p``;

class SealDeal extends React.Component {
  state = {
    preview: false,
    activeAsset: null,
    tabValue: 0,
    newProjectDialogOpen: false,
    hasProjects: true,
  };

  openPreview = asset => {
    this.setState({
      preview: true,
      activeAsset: asset,
    });
  };

  closePreview = () => {
    this.setState({
      preview: false,
      activeAsset: null,
    });
  };

  constructor(props) {
    super(props);
    props.setCurrentProjectId(props.match.params.projectId);
    props.getCurrentProject(props.match.params.projectId);
    props.setCurrentTicketId(props.match.params.ticketId);
    props.getCurrentTicket(
      props.match.params.projectId,
      props.match.params.ticketId
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      nextProps.getCurrentTicket(
        nextProps.match.params.projectId,
        nextProps.match.params.ticketId
      );
      nextProps.setCurrentTicketId(nextProps.match.params.ticketId);
      // if (nextProps.tickets.find(ticket => ticket.ticketId.toString() === nextProps.match.params.ticketId.toString())!== undefined) {
      //     this.props.history.push("/demand");
      // }
    }
  }

  publishTicket = (projectId, ticketId) => event => {
    axios
      .put('/project/' + projectId + '/ticket/' + ticketId + '/publish')
      .then(response => {
        if (response.status === 200) {
          this.props.history.push('/demand/project/' + projectId);
        }
      })
      .catch(err => {
        if (err.response) {
          console.log('error', err.response.data.message);
        }
      });
  };

  handleClose = () => {
    this.setState({ newProjectDialogOpen: false });
  };

  separateNotes = note => {
    const checkIfCanDecode = item => {
      try {
        const decode = decodeURI(item);
        return decode;
      } catch (err) {
        return item;
      }
    };
    if (note) {
      // const sanitizer = dompurify.sanitize;
      // let noteSanitizer = sanitizer(note);

      let noteSanitizer = note;
      let split = noteSanitizer.split('_$_');
      return split.map((el, index) => (
        <Note key={index}>
          <NoteNumb>{index + 1 + '. '}</NoteNumb> {checkIfCanDecode(el)}
        </Note>
      ));
    }
  };

  setNameValueAndUnit = (id, name, value, unit) => {
    if (
      id === 132 ||
      id === 389 ||
      id === 270 ||
      id === 318 ||
      id === 319 ||
      id === 320 ||
      id === 321 ||
      id === 322 ||
      id === 323 ||
      id === 324 ||
      id === 325 ||
      id === 391 ||
      // id === 326 ||
      // id === 327 ||
      // id === 328 ||
      // id === 329 ||
      id === 330 ||
      id === 1304 ||
      id === 261
    ) {
      if (unit === null) {
        return value;
      } else {
        return value + ' ' + unit;
      }
    } else {
      if (value === null) {
        if (unit === null) {
          return name;
        } else {
          return name + ' ' + unit;
        }
      } else if (unit === null) {
        if (id === 331) {
          return value;
        }
        return name + ' ' + value + ' ';
      } else {
        if (id === 63 || id === 111) {
          return name + ': ' + value + unit;
        } else if (id === 376) {
          return value + unit;
        } else if (id === 568) {
          return name + value + unit;
        }
        return name + ': ' + value + unit + ' ';
      }
    }
  };

  renderCriteriaValues = () => {
    if (
      this.props.currentTicket &&
      Object.keys(this.props.currentTicket).length > 0
    ) {
      let filteredCriteria = this.props.currentTicket.criteriaValues
        .map(({ criteria, ...restOfObject }) => {
          if (criteria === undefined) {
            return false;
          }
          return {
            criteria: criteria
              .map(({ criteria, ...restOfObject }) => {
                if (criteria === undefined) {
                  return { ...restOfObject };
                }
                return {
                  criteria: criteria.filter(
                    tertiaryCriteria => tertiaryCriteria.checked
                  ),
                  ...restOfObject,
                };
              })
              .filter(({ criteria }) => {
                if (criteria === undefined) {
                  return false;
                }
                return criteria.length !== 0;
              }),
            ...restOfObject,
          };
        })
        .filter(({ criteria }) => {
          if (criteria === undefined) {
            return false;
          }
          return criteria.length !== 0;
        });
      return (
        <Grid container spacing={0}>
          <Grid
            item
            // lg={4}
            xs={12}
            className="ticket-details"
          >
            {/* <Grid container spacing={0}>
              <Grid item md={6} xs={12}>
                <Grid container spacing={0}>
                  <Grid
                    item
                    // lg={4}
                    // md={3}
                    xs={4}
                    className="ticket-details "
                  >
                    <div className="t-primary-12 t-weight-b u-mrg-bot-20">
                      Ticket reference:
                    </div>
                  </Grid>
                  <Grid
                    item
                    // lg={4}
                    // md={3}
                    xs={8}
                    className="ticket-details pad-l-8"
                  >
                    <div className="t-primary-14 c-gray-light">
                      {this.props.currentTicket.referenceName}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid> */}

            <Grid container spacing={0}>
              {filteredCriteria.map(primaryCriteria => (
                <Grid container spacing={0} key={primaryCriteria.id}>
                  <Grid
                    item
                    // lg={4}
                    // md={6}
                    xs={12}
                    className="ticket-details "
                  >
                    <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10 ">
                      {primaryCriteria.name}
                    </h2>
                  </Grid>
                  <Grid container spacing={0} className="test">
                    {primaryCriteria.criteria.map(secondaryCriteria => (
                      <Grid
                        item
                        // lg={4}
                        md={6}
                        xs={12}
                        className="ticket-details u-mrg-bot-3 checklist-criteria-element-wrapper2 "
                        key={secondaryCriteria.id}
                      >
                        <div className="pad-10-criteria ">
                          <Grid
                            container
                            spacing={0}
                            key={secondaryCriteria.id}
                            className="checklist-criteria-element pad-8-y "
                          >
                            <Grid
                              item
                              // lg={4}
                              // md={6}
                              xs={4}
                              className="ticket-details "
                            >
                              <div className="t-primary-12 t-weight-b ">
                                {secondaryCriteria.name}:
                              </div>
                            </Grid>
                            <Grid
                              item
                              // lg={4}
                              // md={6}
                              xs={8}
                              className="ticket-details u-mrg-bot-3  vertical-align-text"
                            >
                              <div className="t-primary-14 c-gray-light criteria-description">
                                {secondaryCriteria.criteria.map(
                                  tertiaryCriteria => (
                                    <span key={tertiaryCriteria.id}>
                                      {this.setNameValueAndUnit(
                                        tertiaryCriteria.id,
                                        tertiaryCriteria.name,
                                        tertiaryCriteria.value,
                                        tertiaryCriteria.unit
                                      )}
                                    </span>
                                  )
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <div className="spacer-2 spacer-ticket" />
            <Grid container spacing={16}>
              {this.props.currentTicket.assets && (
                <Grid
                  item
                  // lg={4}
                  md={6}
                  xs={12}
                  className="ticket-details"
                >
                  <h2 className="t-primary-16 t-weight-b u-mrg-bot-3 u-mrg-top-10">
                    Photos
                  </h2>
                  <Grid container spacing={16}>
                    {this.props.currentTicket.assets
                      ? this.props.currentTicket.assets.map((asset, index) => (
                          <Fragment>
                            <Grid
                              item
                              // lg={4}
                              md={6}
                              xs={12}
                              className="ticket-details"
                              key={index}
                            >
                              <img
                                className="imagesRadius"
                                src={API_ROOT + '/asset/' + asset}
                                alt=""
                                onClick={() => this.openPreview(asset)}
                              />
                            </Grid>
                            <PreviewImageModal
                              open={this.state.preview}
                              onClose={this.closePreview}
                              image={this.state.activeAsset}
                            />
                          </Fragment>
                        ))
                      : null}
                  </Grid>
                </Grid>
              )}

              {this.props.currentTicket.note && (
                <Grid
                  item
                  // lg={4}
                  md={6}
                  xs={12}
                  className="ticket-details"
                >
                  <h2 className="t-primary-16 t-weight-b u-mrg-bot-3 u-mrg-top-20">
                    Notes
                  </h2>
                  <Grid container spacing={0}>
                    <Grid
                      item
                      // lg={4}
                      // md={6}
                      xs={12}
                      className="ticket-details t-primary-14 c-gray-light lh-16"
                    >
                      <Notes id={'allNotes'} className="u-mrg-bot-5">
                        {this.separateNotes(this.props.currentTicket.note)}
                      </Notes>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item>
                {this.props.currentTicket.circularEconomyGroups && (
                  <h2 className="t-primary-16 t-weight-b u-mrg-bot-3 u-mrg-top-20">
                    Circular Economy Assessment
                  </h2>
                )}
                {this.props.currentTicket.circularEconomyGroups &&
                  this.props.currentTicket.circularEconomyGroups.map(item => (
                    <Grid item>
                      <Grid
                        item
                        className="t-primary-15 t-weight-b u-mrg-bot-3 u-mrg-top-20"
                      >
                        <em>{item.text}</em>
                      </Grid>
                      <Grid item>
                        {item.questions.map(question => (
                          <Grid
                            item
                            className="t-primary-13 t-weight-b u-mrg-bot-3 u-mrg-top-20 w60"
                          >
                            {question.text}
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  ))}
                <Divider className="u-mrg-top-10 u-mrg-bot-10" />
              </Grid>
              <Grid item xs={12} className="u-mrg-top-20">
                <Grid container spacing={32} justify="center">
                  <Grid item md={3} style={{ textAlign: 'center' }}>
                    <Buttons
                      fullWidth
                      classes={{
                        root: 't-primary-16 ',
                      }}
                      variant="contained"
                      color="primary"
                      component={Link}
                      to={`/demand/project/${this.props.match.params.projectId}`}
                    >
                      CANCEL
                    </Buttons>
                  </Grid>
                  <Grid item md={3} style={{ textAlign: 'center' }}>
                    <Buttons
                      fullWidth
                      classes={{
                        root: 't-primary-16 ',
                      }}
                      variant="contained"
                      color="primary"
                      component={Link}
                      to={{
                        pathname: `/demand/project/${this.props.match.params.projectId}/ticket/${this.props.match.params.ticketId}/edit`,
                        state: { projectId: this.props.match.params.projectId },
                      }}
                    >
                      EDIT
                    </Buttons>
                  </Grid>
                  <Grid item md={3} style={{ textAlign: 'center' }}>
                    <Buttons
                      fullWidth
                      disabled={
                        this.props.currentTicket.ticketState === 'DRAFT'
                          ? moment(
                              this.props.currentTicket.validUntil
                            ).isBefore()
                            ? true
                            : false
                          : true
                      }
                      classes={{
                        root: 't-primary-16 ',
                      }}
                      variant="contained"
                      color="primary"
                      onClick={this.publishTicket(
                        this.props.match.params.projectId,
                        this.props.match.params.ticketId
                      )}
                    >
                      ISSUE
                    </Buttons>
                  </Grid>
                  <GridAndStyleForFavoriteBtn
                    item
                    md={3}
                    style={{ textAlign: 'center' }}
                  >
                    {/* <Button
                      color="secondary"
                      className={
                        this.props.currentTicket.favorite
                          ? 't-primary-16 btn-yellow'
                          : 't-primary-16 btn-white'
                      }
                      onClick={() =>
                        this.props.toggleTicketFavorite(
                          this.props.match.params.projectId,
                          this.props.match.params.ticketId
                        )
                      }
                    >
                      Favourite
                    </Button> */}
                    <FavButton
                      favorited={this.props.currentTicket.favorite}
                      toggleTicketFavorite={this.props.toggleTicketFavorite}
                      projectId={this.props.match.params.projectId}
                      ticketId={this.props.match.params.ticketId}
                    />
                  </GridAndStyleForFavoriteBtn>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    }
  };

  render() {
    const { tabValue } = this.state;

    return (
      // Page with tickets

      <TicketWrapper item className="flex-dashboard">
        <Header
          ticketData={
            this.props.currentTicket ? this.props.currentTicket : null
          }
          history={this.props.history}
        />
        <SubHeaderTicketDetail
          ticket={this.props.currentTicket ? this.props.currentTicket : null}
        />

        <ContainerMax>{this.renderCriteriaValues()}</ContainerMax>
      </TicketWrapper>
    );
  }
}

const mapStateToProps = store => {
  return {
    tickets: store.currentProject.tickets,
    currentTicket: store.currentProject.currentTicket,
  };
};
const mapDispatchToProps = dispatch => ({
  getCurrentProject: projectId => {
    dispatch(getCurrentProject(projectId));
  },
  getUsersInvited: projectId => {
    dispatch(getUsersInvited(projectId));
  },
  getCurrentTicket: (projectId, ticketId) => {
    dispatch(getCurrentTicket(projectId, ticketId));
  },
  toggleTicketFavorite: (projectId, ticketId) => {
    dispatch(toggleTicketFavorite(projectId, ticketId));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(SealDeal);
